var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSantaHat = function SvgSantaHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 82,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F73A54",
    d: "M45.185.099c22.606-1.43 58.931 13.055 52.937 34.1-4.313 15.155-4.985 29.47-4.985 29.47l-3.275.286s.662-16.894-8.154-26.88c-2.32-2.626-7.386-9.297-7.386-9.297s-4.847.191-4.928 7.467l-.082 7.277-62.748-2.57S17.811 1.836 45.184.098Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7112C",
    d: "M62.432 35.236C62.514 27.961 72 25.226 72 25.226s.558.733 1.387 1.809c-.9 1.094-3.963 5.39-3.995 8.201l-.082 7.277-6.958-.188c.007-.45.024-1.967.08-7.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E4DF",
    d: "M53.521 39.2c-24.519-4.887-28.726-12.478-39.236-11.127C3.775 29.425-2.529 39.322.974 45.543c3.502 6.223 63.466 11.303 70.053 7.523 1.792-1.028 6.022-8.573.143-12.145-2.796-1.701-9.748-.147-17.649-1.721ZM79.14 69.862c-.202-6.71 5.094-12.314 11.828-12.515 6.734-.202 12.357 5.075 12.559 11.786.202 6.71-5.093 12.314-11.827 12.515-6.735.202-12.358-5.075-12.56-11.786Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103 0H0v82h103z"
  })))));
};
export default SvgSantaHat;